const ACCESS_TOKEN_AUTH = "accessAuthToken"
const REFRESH_TOKEN_AUTH = "refreshAuthToken"

class StorageHelper {
  putAccessToken(token: string | null) {
    if (token) {
      localStorage.setItem(ACCESS_TOKEN_AUTH, token)
    } else {
      localStorage.removeItem(ACCESS_TOKEN_AUTH)
    }
  }
  getAccessToken() {
    let result = localStorage.getItem(ACCESS_TOKEN_AUTH)
    if (result !== null) {
      return result
    }
    return null
  }

  putRefreshToken(token: string | null) {
    if (token) {
      localStorage.setItem(REFRESH_TOKEN_AUTH, token)
    } else {
      localStorage.removeItem(REFRESH_TOKEN_AUTH)
    }
  }
  getRefreshToken() {
    let result = localStorage.getItem(REFRESH_TOKEN_AUTH)
    if (result !== null) {
      return result
    }
    return null
  }
}

export default new StorageHelper()
